module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "arrow",
    class: [{
      'right': _vm.right,
      'is-active': _vm.active
    }, _vm.size, _vm.anchorClass],
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 27.48 18.38"
    }
  }, [(_vm.right) ? _c('g', [_c('line', {
    staticClass: "body",
    attrs: {
      "stroke-width": _vm.strokeWidth,
      "x1": "0",
      "y1": "8.9",
      "x2": "26",
      "y2": "8.9"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "head",
    attrs: {
      "stroke-width": _vm.strokeWidth,
      "points": "17.7,17.2 26.1,8.8 18,0.3 "
    }
  })]) : _c('g', [_c('line', {
    staticClass: "body",
    attrs: {
      "stroke-width": _vm.strokeWidth,
      "x1": "26.8",
      "y1": "8.7",
      "x2": "0.8",
      "y2": "8.7"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "head",
    attrs: {
      "stroke-width": _vm.strokeWidth,
      "points": "9.1,0.4 0.7,8.7 8.8,17.2 "
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ba8366c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arrow.vue
// module id = 381
// module chunks = 2